import { DeploymentEnvironmentName } from "@src/appV2/environment";

export interface CognitoConfig {
  userPoolId: string;
  clientId: string;
}

export function getCognitoConfig(environmentName: DeploymentEnvironmentName): CognitoConfig {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (environmentName) {
    case DeploymentEnvironmentName.STAGING: {
      return {
        userPoolId: "us-west-2_HV1ibP3I6",
        clientId: "1rdet93018ud96nj8coknf50l9",
      };
    }

    case DeploymentEnvironmentName.PROD_SHADOW: {
      return {
        userPoolId: "us-west-2_J1NzXj6dv",
        clientId: "2u8qnjaolbdo68kjsvsg3m8blg",
      };
    }

    case DeploymentEnvironmentName.PRODUCTION: {
      return {
        userPoolId: "us-west-2_in7ey5PCw",
        clientId: "5hq35aignj3t5l40vv3qpbb7g2",
      };
    }

    // Development environment by default
    default: {
      return {
        userPoolId: "us-west-2_N0koNIUOZ",
        clientId: "5rbpldo7e62knc0lq0audjvh9k",
      };
    }
  }
}

export const cognitoConfig = getCognitoConfig(
  process.env.REACT_APP_ENVIRONMENT_NAME as DeploymentEnvironmentName
);
